const isSub = window.location.hostname.split(".").length > 2;
const staging = {
  href: "https://sports.staging.funtico.com/",
  host: "sports.staging.funtico.com",
  hostname: "sports.staging.funtico.com",
  origin: "https://sports.staging.funtico.com",
  protocol: "https:",
};
const location = {
  hostname: isSub ? window.location.hostname : staging.hostname,
  protocol: isSub ? window.location.protocol : staging.protocol,
  host: isSub ? window.location.host : staging.host,
  origin: isSub ? window.location.origin : staging.origin,
};

export const funticoUrl = prepend("");
export const summonersUrl = prepend("summoners.");
export const aboutUrl = prepend("about.");
export const faqUrl = prepend("faq.");
export const gameloopUrl = prepend("gameloop.");

function prepend(part) {
  if (isSub) {
    const currentSubdomain = location.hostname.split(".")[0];
    return location.origin.replace(currentSubdomain + ".", part);
  }
  return location.protocol + "//" + part + location.host.replace("sports.", "");
}
